// Note: Below contains functions used for the proceses used to toggle the section & subsection headers.

document.addEventListener('DOMContentLoaded', () => {
	var sections = am.$('.am-section-type-two .am_toggle_title');
	sections.each((i, section) => {
		section.addEventListener('click', (e) => {
			var $target = am.$(e.target);
			if(!$target.hasClass('fa-info-circle')){
				if(!$target.hasClass('am-add-section'))
					$target = $target.parent().closest('.am-add-section');
				toggleSections($target);
			}
		});
	})

	var sub_sections = am.$('.am-subsection-toggle');
	sub_sections.each((i, sub_section) => {
		sub_section.addEventListener('click', (e) => {
			var $target = am.$(e.target);
			if($target.hasClass('fa-angle-down') || $target.hasClass('fa-angle-up')){
				$target = $target.parent().closest('.am_toggle_title--arrow')
			}
			else if(!$target.hasClass('am-section--title')){
				if(!$target.hasClass('am_toggle_title--arrow'))
					$target = $target.children('.am_toggle_title--arrow');
			}

			toggleSections($target, '', true);
		});
	})
});

function toggleSections(element, amClass = 'am-block', subsection = false) {
	var $element = am.$(element);
	if($element.hasClass('am-add-section'))
		element = $element.children('.am_toggle_title--arrow')[0];

	const arrow = am.$(element).children();
	const parent = am.$(element).parent();

	ensureGSAP().then(function(){
		if(!subsection){
			const sibling = am.$(parent.siblings())[0];
			const $sibling = am.$(sibling);
			const $section = am.$(parent).closest('.am-add-section');

			if($sibling.length > 0 && $section.length > 0){
				if($sibling.attr('data-status')==='closed'){
					const tl = gsap.timeline({ defaults: {duration: .25}, onComplete:function(){
						arrow.addClass('fa-angle-up').removeClass('fa-angle-down');
						$sibling.attr('data-status', 'open').removeClass('am-none').css('height', 'auto');
						$section.removeClass('am-add-section--header-radius background-hint--error');
					}})
						tl
							.fromTo(sibling, {height:'0px', opacity:0}, {height: $sibling.data('height') + 'px', opacity:1}, 'ease')
				}else{
					$sibling.attr('data-height', $sibling.height());
					const tl = gsap.timeline({ defaults: {duration: .25}, onComplete:function(){
						arrow.addClass('fa-angle-down').removeClass('fa-angle-up');
						$sibling.attr('data-status','closed').addClass('am-none').removeClass(amClass);
						$section.addClass('am-add-section--header-radius');
					}})
						tl
							.fromTo(sibling, {height: $sibling.data('height'), opacity:1}, {height:'0px', opacity:0}, 'ease')
				}
			}
		}else{
			var $subsection = am.$(parent).children('.am-subsection-content');
			let bottomMargin = true;
			if($subsection.parent().hasClass('am-subsection-toggle--banks'))
				bottomMargin = false;

			if($subsection.attr('data-status')==='closed'){
				const tl = gsap.timeline({ defaults: {duration: .25}, onComplete:function(){
					arrow.addClass('fa-angle-up').removeClass('fa-angle-down');
					$subsection.attr('data-status','open').attr('data-height', '').removeClass('am-subsection-content--no-top-margin').css('height', 'auto');

					if(!bottomMargin)
						$subsection.addClass('open').removeClass('closed');
				}})
					tl
						.fromTo($subsection, {height:'0px', opacity:0}, {height: $subsection.attr('data-height') + 'px', opacity:1}, 'ease');
			}else{
				$subsection.attr('data-height', $subsection.height()).attr('data-width', $subsection.width());
				const tl = gsap.timeline({ defaults: {duration: .25}, onComplete:function(){
					arrow.addClass('fa-angle-down').removeClass('fa-angle-up');
					$subsection.attr('data-status','closed').addClass('am-subsection-content--no-top-margin');

					if(!bottomMargin)
						$subsection.addClass('closed').removeClass('open');
				}})
					tl
						.fromTo($subsection, {height: $subsection.attr('data-height'), width: $subsection.attr('data-width'), opacity:1}, {height:'0px', width: $subsection.attr('data-width'),  opacity:0}, 'ease');
			}
		}
	});
}

function close_sections(el_index = [], def_class = '.am_toggle_title'){
	// Notes: // el_index by defult is empty causing all sections on page to be closed. loading open is required for smother close/opening to retain height of element on load.
	          // pass index values such as 0, 2, 3, etc which will close those sections on page by their index in 'sections' var
	var sections = am.$(def_class);
	sections.each( (i, el) => {
		var $section_wrapper = am.$(el).parent();
		if(el_index.length == 0 || el_index.includes(i)){
			toggleSections(el)
		}
		$section_wrapper.removeClass('am-section-type-two--o0');
	})
}

function close_sections_dynamically(dynamicClass='am_toggle_title_dynamic'){
	var closeSections = check_close_section_flags(dynamicClass);
	if(closeSections.length > 0)
		close_sections(closeSections);
}

function check_close_section_flags(targetClass){
	var sections = am.$('.am_toggle_title');
	var closeSections = [];
	sections.each((i, section) => {
		const $section = am.$(section);
		if($section.hasClass(targetClass))
			closeSections.push(i);
	})
	
	return closeSections;
}